import React, { useState, useEffect } from "react";
import ReusableTable from "../../components/Employee/Table";
import {
  confirmDeletePopup,
  formatDateOnly,
  openAllowanceTypeModal,
  successPopup,
} from "../../util/common";
import TextInput from "../../components/Reusable/TextInput";
import SelectInput from "../../components/Reusable/SelectInput";
import DateInput from "../../components/Reusable/DateInput";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";
import {
  useCreateNewAllowanceType,
  useDeleteAllowanceType,
  useGetAllAllowanceTypesPaginated,
  useGetAllowanceTypeById,
  useUpdateAllowanceType,
} from "../../hooks/usePayroll";
import "./sweetalert.css";
import { toast } from "react-toastify";

function AllowanceListLayout() {
  const [pageCount, setPageCount] = useState(1);
  const navigate = useNavigate();

  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
  });

  const [filter, setFilter] = useState({
    filterField1: "Code",
    filterValue1: null,
  });

  const handleOnPageChange = (pageIndex, pageSize) => {
    setPagination({
      page: pageIndex + 1,
      pageSize,
    });
  };

  const [allowanceTypeRecords, setAllowanceTypeRecords] = useState([]);
  const allowanceTypes = useGetAllAllowanceTypesPaginated();
  const createAllowanceType = useCreateNewAllowanceType();
  const _allowanceType = useGetAllowanceTypeById();
  const updateAllowanceType = useUpdateAllowanceType();
  const deleteAllowanceType = useDeleteAllowanceType();

  const fetchAllowanceTypeRecords = async () => {
    allowanceTypes.mutate(
      {
        page: pagination.page,
        pageSize: pagination.pageSize,
        filterField1: filter.filterField1,
        filterValue1: filter.filterValue1,
      },
      {
        onSuccess: async (result) => {
          if (!result.success) return;
          setAllowanceTypeRecords(result.data.data);
          setPageCount(result.data.pagination.totalPages);
        },
      }
    );
  };

  useEffect(() => {
    fetchAllowanceTypeRecords();
  }, [pagination, filter]);

  const handleEdit = (allowanceType) => {
    if (!allowanceType) return;

    _allowanceType.mutate(allowanceType.id, {
      onSuccess: async (data) => {
        if (!data?.success) return;

        const { id, Code, Description, Deminimis } = data.data;

        const result = await openAllowanceTypeModal({
          id,
          code: Code,
          description: Description,
          deminimis: Deminimis,
        });

        if (!result) return;

        updateAllowanceType.mutate(
          {
            id: result.id,
            code: result.code,
            description: result.description,
            deminimis: result.deminimis,
          },
          {
            onSuccess: (res) => {
              if (res?.success) {
                toast.success(res.message);
                fetchAllowanceTypeRecords();
              }
            },
            onError: (err) => {
              toast.error(err.response?.data?.message || "Error occurred");
            },
          }
        );
      },
    });
  };

  const handleDelete = async (allowanceType) => {
    const isConfirmed = await confirmDeletePopup({
      text: `Are you sure you want to delete ${allowanceType.Code}?`,
    });

    if (isConfirmed) {
      deleteAllowanceType.mutate(allowanceType.id, {
        onSuccess: (data) => {
          successPopup({ text: "Allowance Type deleted successfully." });
        },
      });
    }
  };

  const tableColumns = [
    { accessorKey: "Code", header: "Code" },
    { accessorKey: "Description", header: "Description" },
    { accessorKey: "Deminimis", header: "Deminimis" },
    { accessorKey: "Active", header: "Active" },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => {
        const allowanceType = row.original;

        return (
          <div style={{ display: "flex", gap: "10px" }}>
            <FaEdit
              title="Edit"
              style={{ cursor: "pointer" }}
              onClick={() => handleEdit(allowanceType)}
            />

            <FaTrash
              title="Delete"
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => handleDelete(allowanceType)}
            />
          </div>
        );
      },
    },
  ];

  const handleAddAllowanceType = async () => {
    const result = await openAllowanceTypeModal({
      id: "",
      code: "",
      description: "",
      deminimis: false,
    });

    if (!result) return;

    createAllowanceType.mutate(
      {
        code: result.code,
        description: result.description,
        deminimis: result.deminimis,
      },
      {
        onSuccess: (data) => {
          if (data?.success) {
            toast.success(data.message);
            fetchAllowanceTypeRecords();
          }
        },
        onError: (err) => {
          toast.error(err.response?.data?.message || "Error occurred");
        },
      }
    );
  };

  return (
    <div className="overtime-form-container">
      <h2>Allowance Types List</h2>
      <form className="overtime-form">
        <div className="form-column">
          <TextInput
            label="Code Name"
            placeholder={"ALLOW-001"}
            onChange={(val) => {
              setFilter((prev) => ({
                ...prev,
                filterValue1: val,
              }));
            }}
            value={filter.filterValue1}
          />
        </div>

        <div className="form-group full-width file-upload-section">
          <div className="attendance-filters">
            <div className="action-btns">
              <button
                className="overtime-btn"
                onClick={handleAddAllowanceType}
                type="button"
              >
                + Add Allowance Type
              </button>
            </div>
            <div className="attendance-records">
              <ReusableTable
                data={allowanceTypeRecords}
                columns={tableColumns}
                mode="server"
                initialPageSize={pagination.pageSize}
                onPageChange={handleOnPageChange}
                pageCount={pageCount}
                page={pagination.page - 1}
                pageSize={pagination.pageSize}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default AllowanceListLayout;
